import React, { Component } from 'react';

import './styles.css';

export default class Modal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            whsesUSA: this.whsesArrayUSA,
            whsesMX: this.whsesArrayMX,
            storeSupply: this.whseStoreSupply
        }
    }

    onClose = e => {
        this.props.onClose && this.props.onClose(e);
      };

     whseArray = [];

     whsesArrayUSA = [
        {
            "whse":"10",
            "whseName":"ONTARIO CA                    ",
            "intlCode":"USA",
            "whseCountry":"USA",
            "checked": false
         },
         {
            "whse":"11",
            "whseName":"LAVONIA GA                    ",
            "intlCode":"USA",
            "whseCountry":"USA",
            "checked": false
         },
         {
            "whse":"20",
            "whseName":"HAZLETON                      ",
            "intlCode":"USA",
            "whseCountry":"USA",
            "checked": false
         },
         {
            "whse":"22",
            "whseName":"LEXINGTON TN                  ",
            "intlCode":"USA",
            "whseCountry":"USA",
            "checked": false
         },
         {
            "whse":"30",
            "whseName":"REDLANDS CA                   ",
            "intlCode":"USA",
            "whseCountry":"USA",
            "checked": false
         },
         {
            "whse":"33",
            "whseName":"DANVILLE IL                   ",
            "intlCode":"USA",
            "whseCountry":"USA",
            "checked": false
         },
         {
            "whse":"55",
            "whseName":"DALLAS                        ",
            "intlCode":"USA",
            "whseCountry":"USA",
            "checked": false
         },
         {
            "whse":"66",
            "whseName":"OCALA                         ",
            "intlCode":"USA",
            "whseCountry":"USA",
            "checked": false
         },
         {
            "whse":"69",
            "whseName":"CUSTOM GOODS LLC              ",
            "intlCode":"USA",
            "whseCountry":"USA",
            "checked": false
         },
         {
            "whse":"77",
            "whseName":"PHOENIX AZ                    ",
            "intlCode":"USA",
            "whseCountry":"USA",
            "checked": false
         },
         {
            "whse":"88",
            "whseName":"PASCO                         ",
            "intlCode":"USA",
            "whseCountry":"USA",
            "checked": false
         },
         {
            "whse":"99",
            "whseName":"ZANESVILLE OH                 ",
            "intlCode":"USA",
            "whseCountry":"USA",
            "checked": false
         }
     ];

     whsesArrayMX = [
        {
            "whse":"52",
            "whseName":"LAREDO TX                     ",
            "intlCode":"USA",
            "whseCountry":"MEX",
            "checked": false
         },
         {
            "whse":"54",
            "whseName":"TEPEJI DEL RIO                ",
            "intlCode":"MEX",
            "whseCountry":"MEX",
            "checked": false
         },
         {
            "whse":"57",
            "whseName":"LAREDO DC (DC 57)             ",
            "intlCode":"USA",
            "whseCountry":"MEX",
            "checked": false
         },
         {
            "whse":"58",
            "whseName":"MONTERREY                     ",
            "intlCode":"MEX",
            "whseCountry":"MEX",
            "checked": false
         },
         {
            "whse":"86",
            "whseName":"HERMOSILLO                    ",
            "intlCode":"MEX",
            "whseCountry":"MEX",
            "checked": false
         }
     ];

     whseStoreSupply = [
        {
            "whse":"92",
            "whseName":"STORE SUPPLY                  ",
            "intlCode":"USA",
            "whseCountry":"STORESUP",
            "checked": false
         }
     ]


    onToggle(event, whse, index) {
        if(whse.whseCountry === 'USA') {
            this.setState(state => {
                const whses = state.whsesUSA.map((item, j) => {
                    if(j === index) {
                        if(item.checked === false) {
                            this.whseArray.push(item.whse);
                            return item.checked = true;
                        } else {
                            const index = this.whseArray.indexOf(item.whse);
                            this.whseArray.splice(index, 1);
                            return item.checked = false;
                        }     
                    }
                });
                this.props.onGetArray(this.whseArray);    
                return {
                    whses,
                };
            });
        } else if(whse.whseCountry === 'MEX'){
            this.setState(state => {
                const whses = state.whsesMX.map((item, j) => {
                    if(j === index) {
                        if(item.checked === false) {
                            this.whseArray.push(item.whse);
                            return item.checked = true;
                        } else {
                            const index = this.whseArray.indexOf(item.whse);
                            this.whseArray.splice(index, 1);
                            return item.checked = false;
                        }     
                    }
                });
                this.props.onGetArray(this.whseArray);    
                return {
                    whses,
                };
            });
        } else {
            this.setState(state => {
                const whses = state.storeSupply.map((item, j) => {
                    if(j === index) {
                        if(item.checked === false) {
                            this.whseArray.push(item.whse);
                            return item.checked = true;
                        } else {
                            const index = this.whseArray.indexOf(item.whse);
                            this.whseArray.splice(index, 1);
                            return item.checked = false;
                        }     
                    }
                });
                this.props.onGetArray(this.whseArray);    
                return {
                    whses,
                };
            });
        }
    };

    selectAll(event) {
        const value = event.target.value;
        if(event.target.checked === true) {
            if(value === 'MEX') {
                this.setState(state => {
                    const whses = state.whsesMX.map((item) => {
                        this.whseArray = ["52", "54", "57", "58", "86"];
                        return item.checked = true;
                    });
                    this.props.onGetArray(this.whseArray);    
                    return {
                        whses,
                    };
                });
            }else {
                this.setState(state => {
                    const whses = state.whsesUSA.map((item) => {
                        this.whseArray = ["10", "11", "20", "22", "30", "33", "55", "66", "69", "77", "88", "99"]
                        return item.checked = true;
                    });
                    this.props.onGetArray(this.whseArray);    
                    return {
                        whses,
                    };
                });
                this.setState(state => {
                    const whses = state.storeSupply.map((item) => {
                        return item.checked = true;
                    });
                    return {
                        whses,
                    };
                });
            } 
        } else {
            if(value === 'MEX') {
                this.setState(state => {
                    const whses = state.whsesMX.map((item) => {
                        this.whseArray = [];
                        return item.checked = false;
                    });
                    this.props.onGetArray(this.whseArray);    
                    return {
                        whses,
                    };
                });
            }else {
                this.setState(state => {
                    const whses = state.whsesUSA.map((item) => {
                        this.whseArray = [];
                        return item.checked = false;
                    });
                    this.props.onGetArray(this.whseArray);    
                    return {
                        whses,
                    };
                });
                this.setState(state => {
                    const whses = state.storeSupply.map((item) => {
                        return item.checked = false;
                    });
                    return {
                        whses,
                    };
                });
            } 
        }
    }


    render() {
        if(!this.props.show) {
            return null;
        }
        return (
            <div className="modal-dropdownwhse-small-container">
                <div className="header-dropdownwhse">
                    <p>All: </p>
                    <input type="checkbox" id="uswhse" name="uswhse" value="US" className="all-checkbox"  onClick={this.selectAll.bind(this)}/>
                    <label htmlFor="uswhse" className="all-label">US</label>
                    <input type="checkbox" id="mexwhse" name="mexwhse" value="MEX" className="all-checkbox" onClick={this.selectAll.bind(this)}/>
                    <label htmlFor="mexwhse" className="all-label">MEX</label>
                </div>
                <div className="drop-menu">
                    <div className="dpd-1">
                        {
                            this.state.whsesUSA.map((whse, index) => {
                                return (
                                    <div className="checkbox-whse-container" key={whse.whse}>
                                        <label >{whse.whse} - {whse.whseName}</label>
                                        <input type="checkbox" value={whse.whse} checked={whse.checked} className="checkbox-whse" onChange={e =>this.onToggle(e, whse, index)}/>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className="dpd-2">
                        {
                            this.state.whsesMX.map((whse, index) => {
                                return (
                                    <div className="checkbox-whse-container" key={whse.whse}>
                                        <label >{whse.whse} - {whse.whseName}</label>
                                        <input type="checkbox" value={whse.whse} checked={whse.checked} className="checkbox-whse" onChange={e =>this.onToggle(e, whse, index)}/>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>         
        );
    }

}